module.exports = __webpack_public_path__ + "img/map.8bf92896.png";